import { RotateCcw } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { downloadSchedule } from "../../lib/schedule-document/download-schedule";
import { dispatchScheduleEvent } from "../../lib/schedule-history/dispatch";
import { Button } from "../ui/button";
import { useScheduleStore } from "../../stores/schedule-store";
import { emptySlot, slotFields } from "../../lib/schedule-document/slot-fields";

export function ResetScheduleButton({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasContent = useScheduleStore(state => {
    const hasSlots = Object.values(state.slots).some(slot =>
      slotFields.some(({ key }) => slot[key] !== emptySlot[key]),
    );
    const hasMessages = Object.values(state.offlineMessages).some(Boolean);
    const hasOfflineDays = Object.values(state.offlineActive).some(Boolean);
    return hasSlots || hasMessages || hasOfflineDays;
  });
  const reset = async () => {
    setOpen(true);
    try {
      const result = await Swal.fire({
        title: t("schedule.resetTitle"),
        text: t("schedule.resetHelp"),
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: t("schedule.reset.all"),
        cancelButtonText: t("schedule.cancel"),
        denyButtonText: t("schedule.saveAndReset"),
        confirmButtonColor: "#dc2626",
        denyButtonColor: "#171717",
        cancelButtonColor: "#737373",
        focusConfirm: false,
        focusCancel: true,
        preDeny: () => {
          try {
            downloadSchedule();
            return true;
          } catch {
            Swal.showValidationMessage(t("schedule.exportError"));
            return false;
          }
        },
      });
      if (result.isConfirmed || result.isDenied) dispatchScheduleEvent({ type: "document/reset" });
    } finally {
      setOpen(false);
    }
  };
  return (
    <Button variant="action" size="sm" disabled={disabled || open || !hasContent} onClick={reset}>
      <RotateCcw />{t("schedule.reset.all")}
    </Button>
  );
}
